import {
  ILanguageOption,
  ILanguages,
  ILocaleCode,
} from '@src/interfaces/locale.interfaces';

export const DEFAULT_LOCALE_CURRENCY = 'usd';
export const DEFAULT_LOCALE_CURRENCY_SYMBOL = '$';

// INFO: add languages here
export const LOCALE_CODE = {
  DA: 'da',
  DE: 'de',
  EL: 'el',
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  IT: 'it',
  NB: 'nb',
  NL: 'nl',
  SV: 'sv',
  PL: 'pl',
} as const;

export const SUPPORTED_LANGUAGES_ARRAY: ILanguages = Object.values(LOCALE_CODE);

// INFO: add language option here
export const LOCALES_OPTIONS_MAP: Partial<
  Record<
    ILocaleCode,
    Partial<Pick<ILanguageOption, 'currency' | 'currencySymbol' | 'region'>>
  >
> = {
  [LOCALE_CODE.NL]: {
    currency: 'eur',
    currencySymbol: '€',
  },
  [LOCALE_CODE.NB]: {
    region: 'NO',
  },
};

export const LOCALES = SUPPORTED_LANGUAGES_ARRAY.reduce(
  (acc, language, idx) => {
    const { region, ...options } = LOCALES_OPTIONS_MAP[language] || {};

    acc[language] = {
      id: idx + 1,
      code: language,
      currency: options.currency || DEFAULT_LOCALE_CURRENCY,
      currencySymbol: options.currencySymbol || DEFAULT_LOCALE_CURRENCY_SYMBOL,
      region: region || language.toUpperCase(),
    };

    return acc;
  },
  {} as Record<ILocaleCode, ILanguageOption>,
);

export const LONG_MONTH_TRANSLATIONS_KEY = [
  'calendar.monthName.January',
  'calendar.monthName.February',
  'calendar.monthName.March',
  'calendar.monthName.April',
  'calendar.monthName.May',
  'calendar.monthName.June',
  'calendar.monthName.July',
  'calendar.monthName.August',
  'calendar.monthName.September',
  'calendar.monthName.October',
  'calendar.monthName.November',
  'calendar.monthName.December',
];

export const WEEKDAYS_SHORT_TRANSLATIONS_KEY = [
  'calendar.dayNameShort.Sun',
  'calendar.dayNameShort.Mon',
  'calendar.dayNameShort.Tue',
  'calendar.dayNameShort.Wed',
  'calendar.dayNameShort.Thu',
  'calendar.dayNameShort.Fri',
  'calendar.dayNameShort.Sat',
];
